import Vue from 'vue';
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(Vuex);
Vue.use(VueAxios, axios)

// eslint-disable-next-line no-unused-vars
import baseStore from "@shared/stores/baseStore";
import {MIDInote} from "@shared/helpers/mappings"
import {MIDIfreq} from "@shared/helpers/mappings"


/*

STORE SPECIFICO PER LA APP

 */


function createSoundTrackFromActiveFrets(matrix) {
    // Create an array to store items with (x, y, value) and boolean
    const items = [];

    // Loop through the matrix and extract items with a boolean value of true
    for (let s = 0; s < matrix.length; s++) {
        for (let f = 0; f < matrix[s].length; f++) {

            if (matrix[s][f].show === true) {
                items.push({
                    'string': s, 'fret': f, 'midi': matrix[s][f].midi
                });
            }
        }
    }

    // Sort the items by integer value
    items.sort((a, b) => a.midi - b.midi);

    // soundTrack si aspetta copie string (range 1-6) e fret
    let buffer = []
    for (let i = 0; i < items.length; i++) {
        buffer.push([items[i]['string'] + 1, items[i]['fret']])
    }

    console.log(buffer);

    return buffer;
}

const appStore = new Vuex.Store({
    state: {},

    getters: {},

    mutations: {

        // eslint-disable-next-line no-unused-vars
        initialiseStore(state) {
            baseStore.state.guitar.chordMode = false;
        },

        // eslint-disable-next-line no-unused-vars
        showMIDI(state) {
            for (let s = 0; s < baseStore.state.guitar.getNumStrings(); s++) {
                for (let f = 0; f < baseStore.state.guitar.getNumFrets(); f++) {
                    baseStore.state.guitar.matrix[s][f].tone = baseStore.state.guitar.matrix[s][f].midi;


                }
            }

            let track = createSoundTrackFromActiveFrets(baseStore.state.guitar.matrix);
            baseStore.state.soundTrack.setTrack(track);

        },

        // eslint-disable-next-line no-unused-vars
        showFrequencies(state) {
            for (let s = 0; s < baseStore.state.guitar.getNumStrings(); s++) {
                for (let f = 0; f < baseStore.state.guitar.getNumFrets(); f++) {
                    baseStore.state.guitar.matrix[s][f].tone = MIDIfreq[parseInt(baseStore.state.guitar.matrix[s][f].midi, 10)];

                }
            }

            let track = createSoundTrackFromActiveFrets(baseStore.state.guitar.matrix);
            baseStore.state.soundTrack.setTrack(track);
        },

        // eslint-disable-next-line no-unused-vars
        showNoteNames(state) {
            for (let s = 0; s < baseStore.state.guitar.getNumStrings(); s++) {
                for (let f = 0; f < baseStore.state.guitar.getNumFrets(); f++) {
                    baseStore.state.guitar.matrix[s][f].tone = MIDInote[parseInt(baseStore.state.guitar.matrix[s][f].midi, 10)];

                }
            }

            let track = createSoundTrackFromActiveFrets(baseStore.state.guitar.matrix);
            baseStore.state.soundTrack.setTrack(track);
        },

        // eslint-disable-next-line no-unused-vars
        showAllFrets(state) {
            for (let s = 0; s < baseStore.state.guitar.getNumStrings(); s++) {
                for (let f = 0; f < baseStore.state.guitar.getNumFrets(); f++) {

                    baseStore.state.guitar.matrix[s][f].show = true;
                }
            }

            let track = createSoundTrackFromActiveFrets(baseStore.state.guitar.matrix);
            baseStore.state.soundTrack.setTrack(track);
        },


        // eslint-disable-next-line no-unused-vars
        clearFretboard(state) {
            baseStore.state.guitar.hideAllFrets();

            let track = createSoundTrackFromActiveFrets(baseStore.state.guitar.matrix);
            baseStore.state.soundTrack.setTrack(track);
        }


    }


})


export default appStore;
